import baseAPI from '@/api/base';
import { EditJobApplication, GetJobApplication, GetJobApplicationStats } from '@/dtos/job_application';
import {
  DELETE_JOB_APPLICATION_URL,
  EDIT_JOB_APPLICATION_URL,
  GET_JOB_APPLICATION_URL,
  GET_JOB_APPLICATION_STATS_URL,
  REGISTER_JOB_APPLICATION_URL,
  TOGGLE_JOB_APPLICATION_IS_ACTIVE_URL,
  UPDATE_JOB_APPLICATION_STATUS_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class JobApplication {
  static getJobApplications = async (getJobApplication: GetJobApplication): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_JOB_APPLICATION_URL, {
      params: getJobApplication,
    });
    console.log('response', response);
    return response;
  };

  static registerJobApplication = async (formData: FormData): Promise<any> => {
    try {
      const response: AxiosResponse = await baseAPI.post(REGISTER_JOB_APPLICATION_URL, formData, {
        skipGlobalErrorHandler: true,
        transformRequest: [(data: any, headers: any) => {
          if (data instanceof FormData) {
            delete headers['Content-Type'];
          }
          return data;
        }],
      } as any);
      return { ok: true, status: response.status, data: response.data?.data, raw: response };
    } catch (error: any) {
      return {
        ok: false,
        status: error?.response?.status,
        message: error?.response?.data?.message,
        data: error?.response?.data,
      };
    }
  };

  static editJobApplication = async (payload: EditJobApplication | FormData): Promise<any> => {
    try {
      const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
      const response: AxiosResponse = await baseAPI.put(
        EDIT_JOB_APPLICATION_URL,
        isFormData ? payload : { ...(payload as EditJobApplication) },
        {
          skipGlobalErrorHandler: true,
          transformRequest: [(data: any, headers: any) => {
            if (data instanceof FormData) {
              delete headers['Content-Type'];
            }
            return data;
          }],
        } as any,
      );
      return { ok: true, status: response.status, data: response.data?.data, raw: response };
    } catch (error: any) {
      return {
        ok: false,
        status: error?.response?.status,
        message: error?.response?.data?.message,
        data: error?.response?.data,
      };
    }
  };

  static toggleJobApplicationIsActive = async (
    editJobApplication: EditJobApplication
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_JOB_APPLICATION_IS_ACTIVE_URL,
      {
        ...editJobApplication,
      }
    );
    return response;
  };

  static updateJobApplicationStatus = async (payload: { id: string; status: string }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(UPDATE_JOB_APPLICATION_STATUS_URL, {
      ...payload,
    });
    return response;
  };

  static getJobApplicationStats = async (params: GetJobApplicationStats): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_JOB_APPLICATION_STATS_URL, {
      params,
    });
    return response;
  };

  static deleteJobApplication = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_JOB_APPLICATION_URL}/${userId}`
    );
    return response;
  };
}

export default JobApplication;
